import { TFunction } from 'i18next';
import { Translations as DriverAssignmentTranslations } from '@bringg/react-components/dist/features/driver-assignment/driver-assignment';
import { Translations as AssignComponentTranslations } from '@bringg/react-components/dist/components/assign-component/assign-component';

export const getAssignDriverTranslations = (
	t: TFunction
): DriverAssignmentTranslations & AssignComponentTranslations => {
	return {
		selectItem: t('ORDER.SELECT_DRIVER'),
		unassigned: t('VEHICLE.UNASSIGNED'),
		driver: t('DRIVER.DRIVER'),
		message: t('TASK.MESSAGE'),
		locate: t('TASK.LOCATE'),
		unassignDriver: t('ORDER.UNASSIGN_DRIVER'),
		driverOffShift: t('MAP_USER_PROFILE.DRIVER_OFF_SHIFT'),
		driverOnShift: t('MAP_USER_PROFILE.DRIVER_ON_SHIFT'),
		driverOnBreak: t('MAP_USER_PROFILE.DRIVER_ON_BREAK'),
		driverUnavailable: t('MAP_USER_PROFILE.DRIVER_UNAVAILABLE')
	};
};
